"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPRECATED_MAP_STYLES = exports.ENGRAIN_API_BASE_URL = void 0;
exports.ENGRAIN_API_BASE_URL = 'https://api.unitmap.com/v1';
exports.DEPRECATED_MAP_STYLES = ['a', 'a.1', 'a.2', 'g.1', 'g.2'];
//# sourceMappingURL=constants.js.map